import * as yup from "yup";

export const createClientSpeReportValidation = () => {
  const schema = yup.object().shape({
    title: yup.string().label('This field').required().max(200),
    description: yup.string().label('This field').required().max(2000),
    visible_to: yup
      .object()
      .label('This field')
      .required()
      .typeError("This field is a required"),
    client_account: yup
      .object()
      .label('This field')
      .required()
      .typeError("This field is a required"),
    client_sub_account: yup
      .object()
      .label('This field')
      .when("visible_to", (visible_to, schema) => {
        if (
          visible_to?.[0].selectOptionLabel === "Client Sub-Account Group" ||
          visible_to?.[0].selectOptionLabel === "Region"
        ) {
          return schema
            .required()
            .test("is-empty-object", "This field is a required", (value) => {
              if (!value) return false; // null or undefined → fail
              return Object.keys(value).length > 0; // {} → fail
            })
            .typeError("This field is a required");
        } else {
          return schema.nullable();
        }
      }),
    service_office: yup.string().label('This field').when("visible_to", (visible_to, schema) => {
      if (visible_to?.[0].selectOptionLabel === "Region") {
        return schema.required();
      } else {
        return schema.optional();
      }
    }),
    csrFile: yup
      .mixed()
      .test(
        "fileReqValidation",
        "This field is required",
        (file) => {
          // console.log("gl-validate:", file)
          return (!!file[0]);
        }
      )
      .test(
        "fileTypeValidation",
        "Only doc/excel/ppt/pdf file types are allowed",
        (file) => {
          /**mime list for doc/excel/ppt/pdf */
          const fileMIMETypeList = [
            /**pdf */
            "application/pdf",
            /**word */
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            /**ppt */
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            /**excel */
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          ];
          //if u want to allow only certain file types only

          return (
            !file[0] || (!!file[0] && fileMIMETypeList.includes(file[0].type))
          );
        }
      )
      .test(
        "fileSizeValidation",
        "The file size should be less than 10MB",
        (file) => {
          // console.log("gl-validate:", file)
          //if u want to allow only certain file sizes
          return !file[0] || (!!file[0] && file[0].size <= 10 * 1024 * 1024);
        }
      ),
  });

  return { schema };
};
